import {changeFieldProperty, setFieldVisibility, setFormButtons} from "../../../../../apps/KpModule/actions";
import {returnButton, saveButton, submitButton} from "../../utils";
import {getRandomListData} from "../../../../../apps/KpModule/selectors";
import {fetchList} from "../../../../../apps/KpModule/actions/api";

export const module_ = {
    name: 'Submission',
    tKey: 'Dépôt dossier',
    object: 'ReliefFund',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: true,
    removable: true,
    defaultSortBy: 'applicationNumber',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'applicationNumber'},
            {path: 'organizationTradingName', tKey: 'tradingName'},
            {path: 'object'},
            {path: 'needsTypes', tKey: 'needs'},
            {path: 'totalTotalAmountsInEuros', tooltip: true},
            {path: 'totalRequestedAmountsInEuros', tooltip: true},
            {path: 'fundingRateForEuros'},
            //{path: 'totalTotalAmountsInKilograms', tooltip: true},
            {path: 'totalRequestedAmountsInKilograms', tooltip: true},
            //{path: 'fundingRateForKilograms'},
            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true},
            {path: 'noDeleteButtonAccess', hidden: true}
        ],
        form: {
            fields: [
                {path: 'object', required: true},
                {path: 'description', tKey: 'Présentation des difficultés rencontrées', type: 'richTextEditor', required: true},
                {path: 'associationUpdatedStatutes', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', required: true},
                {path: 'associationStatusNotice', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', required: true},
                {path: 'latestAssociationReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', required: true},
                {path: 'insuranceContract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', required: true},
                {path: 'bankIdentityStatement', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', required: true},
                {
                    path: 'needs',
                    type: 'accordion',
                    newable: true,
                    removable: true,
                    required: true,
                    viewMap: {
                        dt: [
                            { path: 'natureOfHelp', display: 'nameWithUnit', tKey: 'type'},
                            { path: 'totalAmountInEuros'},
                            { path: 'requestedAmountInEuros'},
                            //{ path: 'totalAmountInKilograms'},
                            { path: 'requestedAmountInKilograms'},
                            //{ path: 'noDeleteButtonAccess' , hidden: true}
                        ],
                        form: [
                            {
                                path: 'natureOfHelp',
                                display: 'nameWithUnit',
                                tKey: 'type',
                                required: true,
                                filters: ['eligibleToEmergencyFund', 'isActive'],
                                fieldPath: ['id', 'name', 'nameWithUnit', 'eligibleToEmergencyFund', 'facilityRelated', 'unit'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeField = needsField.viewMap.form.fields.find(field => field.path === 'landType')
                                        const totalAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInEuros')
                                        const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                        const requestedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInKilograms')
                                        const totalAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInKilograms')
                                        const supportingDocumentsField = needsField.viewMap.form.fields.find(field => field.path === 'supportingDocuments')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')

                                        if(!newValue) landTypeField.setValue(null)
                                        store.dispatch(setFieldVisibility(landTypeField.id, !!newValue && newValue.facilityRelated))
                                        store.dispatch(setFieldVisibility(totalAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))

                                        const hasChanged = !!oldValue && newValue?.id !== oldValue.id
                                        if (hasChanged){
                                            //reset all fields
                                            totalAmountInKilogramsField.setValue(0)
                                            requestedAmountInKilogramsField.setValue(0)
                                            totalAmountInEurosField.setValue(0)
                                            requestedAmountInEurosField.setValue(0)
                                            landTypeField.setValue(null)
                                            landTypeProofField.setValue([])
                                            supportingDocumentsField.setValue([])
                                        }
                                    }
                                }
                            },
                            {
                                path: 'landType', tKey: "Le dossier concerne un lieu", display: 'name', required: true, translate: true, sortList: false,
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')
                                        store.dispatch(setFieldVisibility(landTypeProofField.id, !!newValue))
                                        store.dispatch(changeFieldProperty(landTypeProofField.id, 'tKey', `landTypeProof_${newValue?.id}`))
                                    }
                                }
                            },
                            {
                                path: 'totalAmountInEuros',
                                default: 0,
                                hidden: true,
                                required: true,
                                wholePositiveNumberStrict: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        if(newValue) {
                                            const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                            const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                            store.dispatch(changeFieldProperty(requestedAmountInEurosField.id, 'maxValue', newValue))
                                        }
                                    }
                                }
                            },
                            {path: 'requestedAmountInEuros', hidden: true, default: 0, required: true, wholePositiveNumberStrict: true},
                            {
                                path: 'totalAmountInKilograms',
                                hidden: true,
                                default: 0,
                                required: true,
                                wholePositiveNumberStrict: true
                            },
                            {
                                path: 'requestedAmountInKilograms',
                                hidden: true,
                                default: 0,
                                required: true,
                                wholePositiveNumberStrict: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const totalAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInKilograms')
                                        totalAmountInKilogramsField.setValue(newValue)
                                    }
                                }
                            },
                            { path: 'landTypeProof', required: true, fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', hidden: true },
                            { path: 'supportingDocuments', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', tKey: "needSupportingDocuments_submission", required: true}
                        ]
                    }
                },
                {path: 'associationInformationUpToDate', default: false},
                {path: 'shelterInformationUpToDate', default: false},
                {path: 'shelterCapacityInformationUpToDate', default: false},
                {path: 'statementOfHonestyAndAccuracy'},
                {path: 'conversations', tKey: "interactionZone"},
                {path: 'submitter', fieldPath: ['id', 'firstname', 'lastname', 'mail'], hidden: true},
                {path: 'organization', hidden: true},
                {path: 'buttons', hidden: true}
            ],
            onOpen: ({module, state, store}) => {
                const objectMode = state.ui.objectMode
                if (objectMode === 'newObject') {
                    store.dispatch(setFormButtons([
                        submitButton, saveButton, returnButton
                    ]))
                    store.dispatch(setFieldVisibility('e_landTypeProof', false))
                }

                store.dispatch(fetchList({},'m-C-myOrganization','c.organization','m-C-myOrganization-dt')).then(() => {
                    const state = store.getState()
                    const userOrganization = getRandomListData(state)[0]

                    const firstShelterCheckboxField = module.viewMap.form.fields.find(field => field.path === 'shelterInformationUpToDate')
                    const secondShelterCheckboxField = module.viewMap.form.fields.find(field => field.path === 'shelterCapacityInformationUpToDate')
                    store.dispatch(setFieldVisibility(firstShelterCheckboxField.id, !!userOrganization?.hasShelters))
                    store.dispatch(setFieldVisibility(secondShelterCheckboxField.id, !!userOrganization?.hasShelters))
                })
            }
        }
    },
    filters: [
        'userIsSubmitter',
        {
            path: 'byStatusForSubmission',
            query: () => {
                return {
                    status: { $in: ['draft', 'questioned'] }
                }
            }
        }
    ]
}
